import classNames from 'classnames';
import Button from '@/components/molecules/button/button';
import RoomMatrixDate from '../room-matrix-date/room-matrix-date';
import styles from './room-matrix-navigation.module.scss';

interface RoomMatrixNavigationProps {
  /** Additional class names */
  className?: string;
  /** The columns to show */
  columns?: Content.Components['RoomMatrixColumnDto'][];
  /** Whether to display the loading state */
  isLoading?: boolean;
  /** The change handler */
  onNext: () => void;
  /** The change handler */
  onPrevious: () => void;
  /** The number of columns to show */
  showCount?: number;
  /** The start index */
  startIndex?: number;
}

const RoomMatrixNavigation = ({
  className,
  columns,
  isLoading = false,
  onNext,
  onPrevious,
  showCount = 3,
  startIndex = 0,
}: RoomMatrixNavigationProps) => {
  const hasCharterColumn = columns?.some(column => column.isCharter === true);

  if (isLoading) {
    return (
      <div
        className={classNames(styles.component, styles.isLoading, className)}
      >
        <Button
          className={classNames(styles.button, styles.isPrevious)}
          disabled
          icon="ChevronLeft"
          isSmall
          onClick={onPrevious}
          variant="tertiary"
        />

        {Array.from({ length: showCount }).map((_, index) => (
          <RoomMatrixDate key={index} date="" isLoading weekNumber={null} />
        ))}

        <Button
          className={classNames(styles.button, styles.isNext)}
          disabled
          icon="ChevronRight"
          isSmall
          onClick={onNext}
          variant="tertiary"
        />
      </div>
    );
  }

  return (
    <div
      className={classNames(
        styles.component,
        { [styles.hasCharter]: hasCharterColumn },
        className,
      )}
    >
      <Button
        className={classNames(styles.button, styles.isPrevious)}
        disabled={startIndex === 0}
        icon="ChevronLeft"
        isSmall
        onClick={onPrevious}
        variant="tertiary"
      />

      {columns &&
        columns
          .slice(startIndex, startIndex + showCount)
          .map((column, columnIndex) => (
            <RoomMatrixDate
              key={columnIndex}
              date={column.departureDate}
              isCharter={column.isCharter}
              weekNumber={column.weekNumber}
            />
          ))}

      <Button
        className={classNames(styles.button, styles.isNext)}
        disabled={columns && startIndex + showCount >= columns.length}
        icon="ChevronRight"
        isSmall
        onClick={onNext}
        variant="tertiary"
      />
    </div>
  );
};

RoomMatrixNavigation.displayName = 'RoomMatrixNavigation';

export default RoomMatrixNavigation;
